const Environment = require('./Environment');
const ContentDefault = require('../constants/Content');
const Logger = require('./Logger');

const Content = ContentDefault.default;

const getProductImageByColor = (media, color) => {
  try {
    if (!media || !media.length) {
      return 'https://s3.amazonaws.com/bitsy-product-images/default-product-image.png';
    }
    if (!color || color === 'NONE') return media[0].url;

    const colorIndex = media.map((mediaItem) => mediaItem.color).indexOf(color);

    if (colorIndex === -1) {
      return media[0].url;
    }

    return media[colorIndex].url;
  } catch (e) {
    Logger.error(e);
    return e;
  }
};

const getSubImage = (plan) => {
  try {
    let imageUrl = '';
    if (Environment.store.includes('bump')) {
      imageUrl =
        'https://s3.amazonaws.com/bitsy-product-images/subscription-plan-images/bump/';
    } else {
      imageUrl =
        'https://s3.amazonaws.com/bitsy-product-images/subscription-plan-images/bitsy/';
    }

    if (plan.title === 'Twelve Month') {
      imageUrl += '12-month.png';
    } else if (plan.title === 'Nine Month') {
      imageUrl += '9-month.png';
    } else if (plan.title === 'Six Month') {
      imageUrl += '6-month.png';
    } else if (plan.title === 'Three Month') {
      imageUrl += '3-month.png';
    } else {
      imageUrl += 'monthly.png';
    }

    return imageUrl;
  } catch (e) {
    Logger.error(e);
    return e;
  }
};

const getDataForCart = (cart, includeViewedOn) => {
  try {
    const items = [];
    if (cart.subscription) {
      const { subscription } = cart;
      const imageUrl = getSubImage(subscription.plan);
      items.push({
        SKU: `${subscription.plan.title} ${Content.names.shortName} Subscription`,
        ProductName: `${subscription.plan.title} ${Content.names.shortName} Subscription`,
        Quantity: 1,
        ItemPrice:
          subscription.plan.costWithCoupon || subscription.plan.actualCost,
        RowTotal:
          subscription.plan.costWithCoupon || subscription.plan.actualCost,
        ProductURL: `${Environment.getSelfDomain}/subscribe/select`,
        ImageURL: imageUrl,
      });
    }
    if (cart.productsAndDetails) {
      cart.productsAndDetails.forEach((productsAndDetailsItem) => {
        const { product } = productsAndDetailsItem;
        const mediaUrl = getProductImageByColor(
          product.media,
          productsAndDetailsItem.color,
        );
        const viewedProductData = {
          SKU: product.sku || product.name,
          ProductName: product.name,
          Quantity: productsAndDetailsItem.quantity,
          ItemPrice:
            productsAndDetailsItem.promoItem && product.ownPromoData
              ? product.ownPromoData.cost
              : product.actualCost || 0,
          ProductURL: `${Environment.getSelfDomain}/products/${product.urlName}`,
          ImageURL: mediaUrl,
          Color:
            productsAndDetailsItem.color !== 'NONE'
              ? productsAndDetailsItem.color
              : '',
          Variation:
            productsAndDetailsItem.variation !== 'NONE'
              ? productsAndDetailsItem.variation
              : '',
          ID: product._id,
        };

        if (includeViewedOn) {
          viewedProductData.ViewedOn = new Date();
        }
        items.push(viewedProductData);
      });
    }
    return items;
  } catch (e) {
    Logger.error(e);
    return e;
  }
};

module.exports = {
  getProductImageByColor,
  getSubImage,
  getDataForCart,
};
